module.exports = __webpack_public_path__ + "crazy.4752c6e1.png";